// extracted by mini-css-extract-plugin
module.exports = {"urgentWrapper":"urgentWrapper--nhgS3ynl","urgent":"urgent--2vFmJRsn"};